module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"fr":{"column.inseeCode":"Code INSEE","column.name":"Nom","column.postalCode":"Code postal","column.line5":"Ligne 5","column.routingLabel":"Libellé d\u0027acheminement","column.dateFrom":"Mise en vigueur"}}')
  delete Component.options._Ctor
}
